interface CardsScrollContainerConfig {
	containerClass?: string;
	itemClass?: string;
	sliderClass?: string;
	wrapperClass?: string;
}

export const CardsScrollContainer = {
	containers: [] as HTMLElement[],
	containerClass: 'wv-cards-scroll-container',
	itemClass: 'wv-card',
	sliderClass: 'wv-cards-scroll-container__slider',
	wrapperClass: 'wv-cards-scroll-container__wrapper',

	init(config?: CardsScrollContainerConfig): void {
		if (config?.containerClass !== undefined) this.containerClass = config.containerClass;
		if (config?.itemClass !== undefined) this.itemClass = config.itemClass;
		if (config?.sliderClass !== undefined) this.sliderClass = config.sliderClass;
		if (config?.wrapperClass !== undefined) this.wrapperClass = config.wrapperClass;

		this.bindEvents();
		this.setupScrollContainers();
		this.handleScrollContainers();
	},

	bindEvents(): void {
		window.addEventListener('resize', () => {
			this.setupScrollContainers();
			this.handleScrollContainers();
		});

		window.addEventListener('scroll', () => this.handleScrollContainers(), {passive: true});
	},

	handleScrollContainers(): void {
		const itemSelector = `.${this.itemClass}`;
		const sliderSelector = `.${this.sliderClass}`;
		const wrapperSelector = `.${this.wrapperClass}`;

		const scrollTop = window.pageYOffset;

		this.containers.forEach(container => {
			const items: HTMLElement[] = Array.from(container.querySelectorAll(itemSelector)) as HTMLElement[];
			const slider: HTMLElement = container.querySelector(sliderSelector) as HTMLElement;
			const wrapper: HTMLElement = container.querySelector(wrapperSelector) as HTMLElement;

			if (!items.length || !slider || !wrapper) return;

			const wrapperWidth: number = wrapper.offsetWidth;
			const sliderWidth: number = slider.scrollWidth;

			// if (scrollDistance <= 0) return;

			const start: number = Number(container.dataset.start);
			const end: number = Number(container.dataset.end);

			// Stick to the center
			if (scrollTop >= start && scrollTop <= end) {
				container.classList.add(`${this.containerClass}--sticky-center`);
				container.classList.add(`scroll-container--sticky-center`);
				container.classList.remove(`${this.containerClass}--sticky-end`);
				container.classList.remove(`scroll-container--sticky-end`);
			}
			// Stick to the end
			else if (scrollTop > end) {
				container.classList.add(`${this.containerClass}--sticky-end`);
				container.classList.add(`scroll-container--sticky-end`);
				container.classList.remove(`${this.containerClass}--sticky-center`);
				container.classList.remove(`scroll-container--sticky-center`);
			}
			// Stick to the top
			else {
				container.classList.remove(`${this.containerClass}--sticky-center`);
				container.classList.remove(`scroll-container--sticky-center`);
				container.classList.remove(`${this.containerClass}--sticky-end`);
				container.classList.remove(`scroll-container--sticky-end`);
			}

			const totalScroll: number = end - start;
			const progress: number = Math.max(0, Math.min(totalScroll > 0 ? (scrollTop - start) / totalScroll : 0, 1));

			const activeIndex: number = items.length
				? Math.max(1, Math.round(progress * (items.length - 1)))
				: 1;

			const activeItem: HTMLElement = items[activeIndex];
			const wrapperPadding: number = parseFloat(getComputedStyle(wrapper).paddingLeft || '0') + parseFloat(getComputedStyle(wrapper).paddingRight || '0');
			const translateX: number = activeItem.offsetLeft - (wrapper.offsetWidth / 2 - activeItem.offsetWidth / 2) + wrapperPadding / 2;

			slider.style.transform = `translateX(${-translateX}px)`;

			items.forEach((item, index) => {
				item.classList.toggle(`${this.itemClass}--active`, index === activeIndex);
				item.classList.toggle('scroll-containers-slide--active', index === activeIndex);

				item.classList.toggle(`${this.itemClass}--prev`, index === activeIndex - 1);
				item.classList.toggle('scroll-container-slide--prev', index === activeIndex - 1);

				item.classList.toggle(`${this.itemClass}--next`, index === activeIndex + 1);
				item.classList.toggle('scroll-container-slide--next', index === activeIndex + 1);
			});
		});
	},

	setupScrollContainers(): void {
		const emptySelector: string = `.${this.itemClass}--empty`;
		const containerSelector: string = `.${this.containerClass}`;
		const sliderSelector: string = `.${this.sliderClass}`;
		const wrapperSelector: string = `.${this.wrapperClass}`;
		const scrollTop: number = window.pageYOffset;
		const viewportHeight: number = window.innerHeight;

		this.containers = Array.from(
			document.querySelectorAll(containerSelector)
		) as HTMLElement[];

		this.containers.forEach(container => {
			const wrapper = container.querySelector(wrapperSelector) as HTMLElement;
			const slider = container.querySelector(sliderSelector) as HTMLElement;

			if (!slider || !wrapper) return;

			const wrapperHeight: number = wrapper.offsetHeight;
			const wrapperWidth: number = wrapper.offsetWidth;
			const sliderWidth: number = slider.scrollWidth;
			const scrollDistance: number = sliderWidth - wrapperWidth;

			if (scrollDistance <= 0) return;

			const rect: DOMRect = container.getBoundingClientRect();
			const absoluteTop: number = scrollTop + rect.top;
			const start: number = absoluteTop - (viewportHeight - wrapperHeight) / 2;
			const end: number = start + scrollDistance + (viewportHeight - wrapperHeight);

			container.dataset.start = String(start);
			container.dataset.end = String(end);
			container.style.height = `${scrollDistance + viewportHeight}px`;

			const emptyElements: NodeListOf<HTMLElement> = container.querySelectorAll(emptySelector);

			if (emptyElements.length > 0) return;

			const emptyElement = document.createElement('div');
			emptyElement.classList.add(`${this.itemClass}`);
			emptyElement.classList.add(`${this.itemClass}--empty`);
			emptyElement.classList.add('scroll-container-slide');
			emptyElement.classList.add('scroll-container-slide--empty');

			slider.append(emptyElement);
			slider.prepend(emptyElement);
		});
	}
};
